
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { languageMixin } from "@/mixins/languageMixin";
import MainHeader from "@/components/main-header.vue";
import { GetCountContent } from "@/request/common";
import Empty from "@/components/empty.vue";
@Component({
  components: {
    MainHeader,
    Empty,
  },
})
export default class Name extends mixins(languageMixin) {
  private data: any = [];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private getShowData(item: any) {
    let d: any = [];
    if (item.data.length < 9 || item.ifShowAll) {
      d = item.data;
    } else {
      d = item.data.slice(0, 8);
    }
    return d;
  }
  private goList(items: any, item: any) {
    localStorage.setItem("jiangkangcepingFilter", "");
    this.$router.push({
      path: "/main/assess/shaicha-list",
      query: {
        type: items.value,
        template: JSON.stringify(item),
      },
    });
  }
  private getData() {
    const model: any = JSON.parse(JSON.stringify(this.systemInfo.SETTING.model));
    this.data = [];
    model.forEach((element: any) => {
      this.data.push(this.systemInfo.PART[element]);
    });
    
    this.data.forEach((ele: any) => {
      ele.data = [];
      ele.ifShowAll = false;
      const params: any = {
        params: {
          related_type: ele.value,
        },
      };
      GetCountContent(this, params).then((res: any) => {
        ele.data = res.data[ele.value];
        this.$forceUpdate();
      });
    });
  }
  private mounted() {
    this.getData();
  }
}
